import trackEvent from '@/common/js/track'

export function trackShareboxSw (attrs) {
  trackEvent({
    eventId: 'sailing_c_x_coupon_common_sw',
    eventLabel: '领券页曝光',
    attrs
  })
}

export function trackPrivacyPolicyCk (attrs) {
  trackEvent({
    eventId: 'sailing_c_x_coupon_privacy_policy_ck',
    eventLabel: '隐私条例勾选',
    attrs
  })
}

export function trackOpenBoxCk (attrs) {
  trackEvent({
    eventId: 'sailing_c_x_coupon_receive_ck',
    eventLabel: '点击领取',
    attrs
  })
}

export function trackOpenBoxResultSw (attrs) {
  trackEvent({
    eventId: 'sailing_c_x_coupon_receive_detail_sw',
    eventLabel: '领取结果展示',
    attrs
  })
}

export function trackButtonJumpCk (attrs) {
  trackEvent({
    eventId: 'sailing_c_x_coupon_jump_ck',
    eventLabel: '点击跳转Button',
    attrs
  })
}

export function trackNewUserBannerSw (attrs) {
  trackEvent({
    eventId: 'sailing_c_x_coupon_banner_sw',
    eventLabel: '新用户图片曝光',
    attrs
  })
}

export function trackNewUserBannerCk (attrs) {
  trackEvent({
    eventId: 'sailing_c_x_coupon_banner_ck',
    eventLabel: '点击新用户banner',
    attrs
  })
}

export function trackModifyPhoneCk (attrs) {
  trackEvent({
    eventId: 'sailing_c_x_coupon_modify_account_ck',
    eventLabel: '点击修改手机号',
    attrs
  })
}

export function trackPassportLoadError (attrs) {
  trackEvent({
    eventId: 'tech_passport_load_error',
    eventLabel: 'passport加载失败',
    attrs
  })
}
